import { useEffect, useState } from 'react'
import axios from 'axios'

export const usePendingOrdersCount = (enabled: boolean, refreshKey?: string) => {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!enabled) { setCount(0); return }
    let active = true
    axios.get<{ count: number }>('/api/shop/admin/pending-orders-count')
      .then(({ data }) => { if (active) setCount(data.count) })
      .catch(() => undefined)
    return () => { active = false }
  }, [enabled, refreshKey])

  return count
}
